import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import { db } from "../../firebase/firebaseConfig";
import { collection, query, where, getDocs } from "firebase/firestore";
import { useTranslation } from "react-i18next";
import NotFoundPage from "./NotFoundPage"; // Đổi path nếu cần
import Breadcrumb from "../../components/ui/Breadcrumb";
import SeoMeta from "../../components/ui/SeoMeta";

export default function RichPage(props) {
  const { slug: paramSlug } = useParams();
  const location = useLocation();
  const { i18n } = useTranslation();

  // Fallback theo thứ tự: props.slug → location.state.slug → param
  const slug =
    props.slug || location?.state?.slug || paramSlug || "about";

  const [pageContent, setPageContent] = useState(null);
  const [pageTitle, setPageTitle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    const fetchPage = async () => {
      setNotFound(false);
      setLoading(true);
      try {
        const q = query(
          collection(db, "pages"),
          where("slug", "==", slug)
        );
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
          const data = querySnapshot.docs[0].data();
          const lang = i18n.language || "vi";
          setPageContent(data.content?.[lang] || data.content?.vi || "Không có nội dung.");
          setPageTitle(data.title?.[lang] || data.content?.vi || slug.replaceAll("-", " "));
        } else {
          setNotFound(true);
        }
      } catch (error) {
        setNotFound(true);
        console.error("Lỗi lấy dữ liệu trang:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPage();
  }, [slug, i18n.language]);

  if (loading)
    return (
  <div className="py-6 px-4">
      <div className="p-8 flex flex-col items-center">
        <div className="inline-block w-10 h-10 border-4 border-primary border-t-menu rounded-full animate-spin"></div>
        <div className="mt-4 text-menu text-base">Đang tải kết quả...</div>
      </div>
      </div>
    );

  if (notFound) {
    return <NotFoundPage />;
  }

  return (
    <div className="py-6 px-4">
      <SeoMeta page="rich-page" initialMeta={{title: pageTitle, description: "" }} />
      <Breadcrumb
        items={[
          { label: pageTitle }
        ]}
      />
      <div className="bg-card rounded-2xl shadow p-6 md:p-10 mt-2">
        <h1 className="text-3xl font-extrabold mb-6 text-primary capitalize">
          {pageTitle}
        </h1>
        <div
          className="prose max-w-none prose-h2:text-primary prose-h3:text-menu prose-a:text-primary prose-blockquote:border-l-primary text-text"
          dangerouslySetInnerHTML={{ __html: pageContent }}
        />
      </div>
    </div>
  );
}
